import { useEffect, useState } from 'react';
import OfflineBanner from '../OfflineBanner';
import AppHeader from './AppHeader';
import ImpersonationBanner from './ImpersonationBanner';
import Sidebar from './Sidebar';

const MD_QUERY = '(min-width: 768px)';

const AppShell = ({ children, mainClassName = 'min-w-0 flex-1 overflow-auto p-4 md:p-8' }) => {
  const [drawerOpen, setDrawerOpen] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MD_QUERY).matches : false
  );
  const [isDesktop, setIsDesktop] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(MD_QUERY).matches : false
  );

  useEffect(() => {
    const mq = window.matchMedia(MD_QUERY);
    const onChange = (event) => {
      setIsDesktop(event.matches);
      setDrawerOpen(event.matches);
    };
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  useEffect(() => {
    if (isDesktop || !drawerOpen) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [drawerOpen, isDesktop]);

  const closeDrawer = () => setDrawerOpen(false);

  return (
    <div className="flex min-h-screen min-w-0 flex-col overflow-x-hidden">
      <OfflineBanner />
      <ImpersonationBanner />
      {!isDesktop && drawerOpen && (
        <button
          type="button"
          aria-label="Close menu overlay"
          className="fixed inset-0 z-30 bg-black/50 md:hidden"
          onClick={closeDrawer}
        />
      )}
      <Sidebar
        open={drawerOpen}
        onClose={closeDrawer}
        onNavigate={!isDesktop ? closeDrawer : undefined}
      />
      <div
        className={`flex min-h-0 min-w-0 flex-1 flex-col transition-[padding] duration-200 ${
          drawerOpen ? 'md:pl-72' : ''
        }`}
      >
        <AppHeader onMenuClick={() => setDrawerOpen((open) => !open)} menuOpen={drawerOpen} />
        <main className={mainClassName}>{children}</main>
      </div>
    </div>
  );
};

export default AppShell;
